import { render, staticRenderFns } from "./UiButtonGroups.vue?vue&type=template&id=06c2dc44&"
import script from "./UiButtonGroups.vue?vue&type=script&lang=js&"
export * from "./UiButtonGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports